<template>
  <div class="annual-revenue">
    <div class="revenue-chart">
      <Echart ref="annualChart" :options="chartOptions" style="height: 100%; width: 100%" />
    </div>
    
    <div class="revenue-summary">
      <div class="summary-item">
        <span class="summary-label">{{ $t('应收总额') }}</span>
        <span class="summary-value">{{ shouldChargedTotal }}{{ $t('元') }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">{{ $t('实收总额') }}</span>
        <span class="summary-value">{{ actuallyChargedTotal }}{{ $t('元') }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">{{ $t('收缴率') }}</span>
        <span class="summary-value">{{ collectionRate }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
import { putAction } from '@/api/manage'

export default {
  name: 'AnnualRevenue',
  data() {
    return {
      loading: false,
      shouldChargedTotal: 0,
      actuallyChargedTotal: 0,
      revenueData: {
        monthStrList: [],
        shouldChargedList: [],
        actuallyChargedList: []
      },
      url: {
        list: '/jeecg-charge/meter/waterAnalysis/doQueryChargeMoneyByPriceCode'
      },
      currentYear: 0
    }
  },
  computed: {
    collectionRate() {
      if (this.shouldChargedTotal > 0) {
        return ((this.actuallyChargedTotal / this.shouldChargedTotal) * 100).toFixed(1)
      }
      return 0
    },
    chartOptions() {
      const xData = this.revenueData.monthStrList
      const yData1 = this.revenueData.shouldChargedList
      const yData2 = this.revenueData.actuallyChargedList
      
      return {
        color: ['#50E3C2','#4634FA','#32C5FF','#F6BB2F','#0091FF','#0394FF','#0C2D82','#B620E0','#F7B500','#FA6400','#E02020'],
        grid: {
          top: '20%',
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('金额(元)'),
          nameTextStyle: {
            color: '#CEE2FF',
            fontSize: 10
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 10,
            formatter: (value) => {
              if (value >= 10000) {
                return (value / 10000).toFixed(0) + this.$t('万')
              }
              return value
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          data: [this.$t('应收'), this.$t('实收')],
          textStyle: {
            color: '#CEE2FF'
          },
          icon: 'circle',
          itemHeight: 10,
          left: 'center'
        },
        series: [
          {
            name: this.$t('应收'),
            type: 'pictorialBar',
            barMaxWidth: 22,
            stack: 'sum',
            smooth: true,
            symbol: 'triangle',
            data: yData1,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(80,227,194,0.5)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(80,227,194,0.1)',
                  },
                ],
                global: false,
              },
            },
            z: 10
          },
          {
            name: this.$t('实收'),
            type: 'pictorialBar',
            barMaxWidth: 22,
            barGap: '-40%',
            stack: 'total',
            smooth: true,
            symbol: 'triangle',
            data: yData2,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(70,52,250,0.5)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(70,52,250,0.1)',
                  },
                ],
                global: false,
              },
            },
            z: 100
          }
        ]
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.currentYear = new Date().getFullYear()
      this.queryAnnualRevenue()
    },
    queryAnnualRevenue() {
      this.loading = true
      putAction(this.url.list, { doQueryChargeMoneyByPriceCode: 0 }).then((res) => {
        if(res.success){
          const data = res.result
          this.shouldChargedTotal = data.shouldChargedTotal || 0
          this.actuallyChargedTotal = data.actuallyChargedTotal || 0
          
          if (data.meterIndexPriceChargeVoList) {
            this.revenueData.monthStrList = data.meterIndexPriceChargeVoList.map(item => item.meterUserPriceName)
            this.revenueData.shouldChargedList = data.meterIndexPriceChargeVoList.map(item => item.shouldCharged || 0)
            this.revenueData.actuallyChargedList = data.meterIndexPriceChargeVoList.map(item => item.actuallyCharged || 0)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.annual-revenue {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  
  .revenue-chart {
    flex: 1;
    min-height: 0;
  }
  
  .revenue-summary {
    display: flex;
    justify-content: space-around;
    margin-top: 0.5rem;
    padding: 0.5rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
    border-radius: 8px;
    border: 1px solid rgba(102, 126, 234, 0.2);
  }
  
  .summary-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    
    .summary-label {
      font-size: 0.75rem;
      color: rgba(255, 255, 255, 0.7);
    }
    
    .summary-value {
      font-family: 'ds-digital-bold', monospace;
      font-size: 1rem;
      font-weight: bold;
      color: #667eea;
      text-shadow: 0 0 8px rgba(0, 150, 255, 0.5);
    }
  }
}

@media (max-width: 768px) {
  .annual-revenue {
    .revenue-summary {
      flex-direction: column;
      gap: 0.5rem;
      
      .summary-item {
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
      }
    }
  }
}
</style>